import {Comment} from "../models/comment";


export default function prepareRemoveSampleDTO(plate:any, labID: string, samplePositionList: String[], puid: string, sampleBarcodeMap: Map<string, string>): any {
    const sampleRemovedComment = new Comment();
    const barcodesWithPosition = samplePositionList.map(cell => `Barcode: ${sampleBarcodeMap.get(cell.trim())} Position: ${cell}`).join("\n");
    sampleRemovedComment.comment = `Following samples have been removed from the plate ${plate?.lastUpdatedPlateID} ${barcodesWithPosition} \n (PUID:${puid})`;
    sampleRemovedComment.status = plate?.status;
    sampleRemovedComment.timeStamp = new Date();
    sampleRemovedComment.puid = Comment.GENERATED_BY_SYSTEM_TAG;
    const positions = new Set(samplePositionList);
    const samplesToBeRemoved = plate.samples.filter(sample => positions.has(sample?.position));

    return {
        "samplePositionList": samplePositionList,
        "labID": labID,
        "plateID": plate?.plateID,
        "puid": puid,
        "removedSamples": samplesToBeRemoved,
        "comment": sampleRemovedComment
    }
}
